import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container } from '../../components/ui';
import { ImageCarousel } from '../../components/carousel';
import { apiUrl } from '../../config/api';
import makanan from '../../images/Makanan-dan-Minuman.png';
import buah from '../../images/Buah-dan-Sayuran.png';
import susu from '../../images/Olahan-Susu-dan-Makanan-Beku.png';
import rumah from '../../images/Perlengkapan-Rumah-Tangga.png';
import promo1 from '../../images/promo-1.jpeg';
import promo2 from '../../images/promo-2.jpeg';

const promoCards = [
  { id: 1, title: 'Promo 1', image: null },
  { id: 2, title: 'Promo 2', image: null },
  { id: 3, title: 'Promo 3', image: null },
  { id: 4, title: 'Promo 4', image: null },
];

const portraitSlides = [
  { src: promo1, alt: 'Promo 1' },
  { src: promo2, alt: 'Promo 2' },
];

const slugToFallbackImage = { food: makanan, fresh: buah, snack: susu, household: rumah };
const slugToCategoryLabel = { food: 'Food', fresh: 'Fresh', snack: 'Snack', household: 'Household' };

const defaultCategories = [
  { image: makanan, category: 'Food', title: 'Food', excerpt: 'Makanan & minuman.', slug: 'food' },
  { image: buah, category: 'Fresh', title: 'Fresh', excerpt: 'Buah, sayuran & bahan segar.', slug: 'fresh' },
  { image: susu, category: 'Snack', title: 'Snack', excerpt: 'Cemilan & makanan ringan.', slug: 'snack' },
  { image: rumah, category: 'Household', title: 'Household', excerpt: 'Perlengkapan rumah tangga.', slug: 'household' },
];

export default function Kategori() {
  const [categories, setCategories] = useState(defaultCategories);

  useEffect(() => {
    let cancelled = false;
    fetch(apiUrl('/api/categories/public'))
      .then((res) => res.json())
      .then((data) => {
        if (cancelled || !Array.isArray(data) || data.length === 0) return;
        const ordered = ['food', 'fresh', 'snack', 'household'];
        const list = ordered.map((slug) => {
          const c = data.find((x) => x.slug === slug) || { slug, title: slugToCategoryLabel[slug] || slug, excerpt: '' };
          return {
            slug: c.slug,
            category: slugToCategoryLabel[c.slug] || c.title,
            title: c.title || slugToCategoryLabel[c.slug] || c.slug,
            excerpt: c.excerpt || '',
            image: c.imageUrl || slugToFallbackImage[c.slug] || makanan,
          };
        });
        setCategories(list);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return (
    <main className="min-h-screen">
      <section className="pt-6 pb-4 md:pt-8 md:pb-6">
        <Container>
          <p className="text-sm font-semibold text-am-text-700 mb-3">Promo produk</p>
          <div className="flex gap-3 overflow-x-auto pb-2 -mx-1 px-1 snap-x snap-mandatory">
            {promoCards.map((promo) => (
              <div
                key={promo.id}
                className="flex-shrink-0 w-36 sm:w-40 rounded-xl overflow-hidden border border-am-green-100 bg-white shadow-sm hover:shadow-md transition-shadow snap-start"
              >
                <div className="aspect-square bg-am-green-50 flex items-center justify-center">
                  {promo.image ? (
                    <img src={promo.image} alt={promo.title} className="w-full h-full object-cover" />
                  ) : (
                    <span className="text-xs text-am-text-700 text-center px-2">Promo</span>
                  )}
                </div>
                <div className="p-2 text-center">
                  <span className="text-xs font-medium text-am-text-900 line-clamp-1">{promo.title}</span>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>

      <section className="py-6 md:py-10 pb-16 bg-am-green-50/50">
        <Container>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 items-start w-auto">
            <div className="lg:col-span-5 flex justify-center lg:justify-end order-2 lg:order-1">
              <div className="w-fit max-w-full">
                <ImageCarousel
                  images={portraitSlides}
                  intervalMs={4500}
                  aspect="auto"
                  objectFit="contain"
                />
              </div>
            </div>

            <div className="lg:col-span-7 order-1 lg:order-2 flex">
              <div className="grid grid-cols-2 gap-2 sm:gap-3 max-w-[280px] sm:max-w-[340px]">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/kategori/${cat.slug}`}
                    className="group block"
                  >
                    <article className="overflow-hidden rounded-lg bg-white border border-am-green-50 shadow-sm hover:shadow-md hover:border-am-green-100 transition-all duration-300">
                      <div className="aspect-[16/9] overflow-hidden">
                        <img
                          src={cat.image}
                          alt={cat.title}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                        />
                      </div>
                      <div className="p-1.5 sm:p-2">
                        <span className="text-[9px] sm:text-[10px] font-semibold uppercase tracking-wide text-am-accent-700">
                          {cat.category}
                        </span>
                        <h3 className="mt-0.5 text-xs sm:text-sm font-semibold text-am-text-900 group-hover:text-am-accent transition-colors line-clamp-1">
                          {cat.title}
                        </h3>
                        <p className="mt-0.5 text-[10px] text-am-text-700 line-clamp-1 hidden sm:block">
                          {cat.excerpt}
                        </p>
                        <span className="mt-0.5 inline-flex items-center text-[10px] sm:text-xs font-medium text-am-accent">
                          Lihat
                          <svg className="ml-0.5 w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                          </svg>
                        </span>
                      </div>
                    </article>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </Container>
      </section>
    </main>
  );
}
